<div class="cylon-loader"><div class="loader-wrapper"><div class="loader-bg"><div class="slider"></div></div></div></div>